import React from 'react';
import Hero from '../components/Hero';
import ClientLogos from '../components/ClientLogos';
import CoreServices from '../components/CoreServices';
import IndustrySolutions from '../components/IndustrySolutions';
import ProblemSolution from '../components/ProblemSolution';
import Stats from '../components/Stats';
import ProcessSection from '../components/ProcessSection';
import CTA from '../components/CTA';

const HomePage = () => {
  return (
    <>
      <Hero />
      <ClientLogos />
      <CoreServices />
      <IndustrySolutions />
      <ProblemSolution />
      <Stats />
      <ProcessSection />
      <CTA />
    </>
  );
};

export default HomePage; 